import React from 'react';

import { ReactionType } from '../../../../../../types';
import { ToolbarButton } from '../toolbar-button';
import { useReactionProps } from './use-reaction-props';

type Props = {
    reactionType: ReactionType;
};

export function ReactionButton({ reactionType }: Props) {
    const { onClick, iconName, title, testId } = useReactionProps(reactionType);

    return <ToolbarButton iconName={iconName} onClick={onClick} title={title} testId={testId} />;
}
